import React from "react";
import ClientList from "./ClientList/ClientList";

const ClientListPage = () => {
  return <ClientList />;
};

export default ClientListPage;
